import axios from 'axios';
import {apiService} from "../../services/api.service";
import {convertToPageable, extractData, handleResponse} from "../../helpers/apiResponseHelper";
import {GhgEmissionPeriodRequest} from "./models";

async function findGhgEmissionPeriods(pageRequest: any) {
    return axios.get(`${apiService.getApiUrl()}/ghg-emission-periods/admin`, {
        params: pageRequest
    }).then(handleResponse).then(convertToPageable);
}

async function postGhgEmissionPeriod(request: GhgEmissionPeriodRequest) {
    return axios.post(`${apiService.getApiUrl()}/ghg-emission-periods/admin`,
        {
            ...request
        }).then(handleResponse).then(extractData);
}

async function putGhgEmissionPeriod(id: number, request: GhgEmissionPeriodRequest) {
    return axios.put(`${apiService.getApiUrl()}/ghg-emission-periods/admin/${id}`,
        {
            ...request
        }).then(handleResponse).then(extractData);
}

async function deleteGhgEmissionPeriod(id: number) {
    return axios.delete(`${apiService.getApiUrl()}/ghg-emission-periods/admin/${id}`)
        .then(handleResponse);
}

export const GhgEmissionPeriodsService = {
    findGhgEmissionPeriods,
    postGhgEmissionPeriod,
    putGhgEmissionPeriod,
    deleteGhgEmissionPeriod
};
